import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, Inject, Input, OnInit } from '@angular/core';

import { ICustomSelect } from 'src/app/models/generic';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailService } from 'src/app/services/api/email.service';
import { IEmailTemplateInfo } from 'src/app/models/email';
import { DialogEmailTypeEnum } from './../../../../models/email';

@Component({
  selector: 'app-modal-add-email',
  templateUrl: './modal-add-email.component.html',
  styleUrls: ['./modal-add-email.component.scss']
})
export class ModalAddEmailComponent implements OnInit {
  bankOpts: ICustomSelect[] = [];
  channelOpts: ICustomSelect[] = [];

  form!: FormGroup<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { bankOpts: ICustomSelect[]; channelOpts: ICustomSelect[] },
    private _emailService: EmailService,
    public dialogRef: MatDialogRef<ModalAddEmailComponent>
  ) {
    this.bankOpts = data.bankOpts;
    this.channelOpts = data.channelOpts;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.form = new FormGroup<any>({
      Channel: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }

  handleAddConfig(): void {
    const template: IEmailTemplateInfo = {
      CompanyId: null,
      EventName: `${this.form.controls['Channel'].value}.${DialogEmailTypeEnum.Transfer}`,
      EventType: `${DialogEmailTypeEnum.Transfer}`,
      Subject: 'Novo template',
      Template: ''
    };

    this._emailService.createTemplate(template).subscribe({
      next: (response) => {
        this.dialogRef.close(response.Data);
      }
    });
  }
}
